import React, { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Home";
import Header from '../component/Header';
import Footer from '../component/Footer';
import Inquiry from "../component/Contact";
import VASActivity from "../pages/VASActivity";
import Services from "../pages/Services";
import Warehousing from "../pages/Warehousing";
import Transpotation from "../pages/Transpotation";



export default function Router() {
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);
    const [headerData, setHeaderData] = useState([]);


    return (
        <>
            <BrowserRouter>

                <Header setHeaderData={setHeaderData} />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/warehousing" element={<Warehousing />} />
                    <Route path="/vas-activity" element={<VASActivity />} />
                    <Route path="/transportation" element={<Transpotation />} />
                    <Route path="/contact" element={<Inquiry />} />
                </Routes>
                <Footer setHeaderData={setHeaderData} />
            </BrowserRouter >
        </>
    );
}